import { render, staticRenderFns } from "./Infobar.vue?vue&type=template&id=59df8678&"
import script from "./Infobar.vue?vue&type=script&lang=js&"
export * from "./Infobar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports